import {
  Button, ButtonGroup, Grid, TextField, Checkbox, FormGroup, FormControlLabel,
  Card, Box, CardContent
} from '@material-ui/core';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TableNavigationSearchTags from './TableNavigationSearchTags';

const TableNavigationSearch = ({ loading, bookStore, userStore }) => {
  const [bookId, setBookId] = useState('');
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [isbn, setIsbn] = useState('');
  const [showNoMainBook, setShowNoMainBook] = useState(false);
  const [showOnlyWantToRead, setShowOnlyWantToRead] = useState(false);
  const [showOnlyAlreadyRead, setShowOnlyAlreadyRead] = useState(false);
  const [showOnlyEnabled, setShowOnlyEnabled] = useState(false);
  const [tagsAdmin, setTagsAdmin] = useState([]);

  const resetForm = async () => {
    setBookId('');
    setTitle('');
    setAuthor('');
    setIsbn('');
    setShowNoMainBook(false);
    setShowOnlyWantToRead(false);
    setShowOnlyAlreadyRead(false);
    setShowOnlyEnabled(false);
    setTagsAdmin([]);

    bookStore.setIsLoading(true);
    await bookStore.setFilters({});
    bookStore.setIsLoading(false);
  }

  const handleSubmit = async () => {
    bookStore.setIsLoading(true);
    await bookStore.setFilters({ bookId, title, author, isbn, showNoMainBook, showOnlyWantToRead, showOnlyAlreadyRead, showOnlyEnabled, tagsAdmin });
    bookStore.setIsLoading(false);
  }

  return (
    <Card>
      <Box>
        <CardContent>
          <form onSubmit={ (e) => {
            e.preventDefault();
            handleSubmit();
          } }>
            <Grid container spacing={2} alignItems='center' justifyContent="space-between">
              <Grid item xs={5}>
                <Grid container spacing={2} item>
                  <Grid item xs={6}>
                    <TextField
                      label='ID'
                      name='book_id'
                      type='text'
                      value={ bookId }
                      onChange={ e => setBookId(e.target.value) }
                      size='small'
                      margin='dense'
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label='Título'
                      name='title'
                      type='text'
                      value={ title }
                      onChange={ e => setTitle(e.target.value) }
                      size='small'
                      margin='dense'
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} item>
                  <Grid item xs={6}>
                    <TextField
                      label='Autor'
                      name='author'
                      type='text'
                      value={ author }
                      onChange={ e => setAuthor(e.target.value) }
                      size='small'
                      margin='dense'
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label='ISBN'
                      name='isbn'
                      type='text'
                      value={ isbn }
                      onChange={ e => setIsbn(e.target.value) }
                      size='small'
                      margin='dense'
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={7}>
                <Grid container spacing={1} item>
                  <Grid item xs={4}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox checked={ showNoMainBook }
                                    onChange={ (e) => setShowNoMainBook(e.target.checked) } />
                        } label='Mostrar apenas livros filhos sem pais vinculados' />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={4}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox checked={ showOnlyAlreadyRead }
                                    onChange={ (e) => setShowOnlyAlreadyRead(e.target.checked) } />
                        } label='Mostrar apenas livros adicionados a listas de lidos' />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={4}>
                    <TableNavigationSearchTags userStore={ userStore } setSelectedTags={ setTagsAdmin } selectedTags={tagsAdmin} />
                  </Grid>
                </Grid>
                <Grid container spacing={2} item>
                  <Grid item xs={4}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox checked={ showOnlyWantToRead }
                                    onChange={ (e) => setShowOnlyWantToRead(e.target.checked) } />
                        } label='Mostrar apenas livros adicionados a listas para ler' />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={4}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox checked={ showOnlyEnabled }
                                    onChange={ (e) => setShowOnlyEnabled(e.target.checked) } />
                        } label='Mostrar apenas livros ativos' />
                    </FormGroup>
                  </Grid>
                </Grid>

              </Grid>

              <Grid item xs={2}>
                <ButtonGroup>
                  <Button
                    color='primary'
                    type='submit'
                    disabled={ loading }
                    size='large'
                    variant='contained'
                  >
                    Pesquisar
                  </Button>
                  <Button
                    color='primary'
                    variant='outlined'
                    disabled={ loading }
                    onClick={ () => {
                      resetForm();
                    } }
                  >
                    Limpar
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Box>
    </Card>

  );
};

TableNavigationSearch.propTypes = {
  changeSearchTerm: PropTypes.func
};

export default TableNavigationSearch;
